var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.35481 21.9015H21.7332C23.1096 21.8295 24.168 20.6571 24.0972 19.2807C24.0816 19.0023 24.0216 18.7275 23.916 18.4707L15.1836 3.18747C14.5164 1.98147 12.9984 1.54467 11.7924 2.21307C11.382 2.43867 11.0436 2.77707 10.8168 3.18747L2.08441 18.4707C1.56601 19.7475 2.18041 21.2019 3.45601 21.7215C3.71521 21.8259 3.98881 21.8859 4.26721 21.9015",
    fill: "#C05717"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.35481 21.9015H21.7332C23.1096 21.8295 24.168 20.6571 24.0972 19.2807C24.0816 19.0023 24.0216 18.7275 23.916 18.4707L15.1836 3.18747C14.5164 1.98147 12.9984 1.54467 11.7924 2.21307C11.382 2.43867 11.0436 2.77707 10.8168 3.18747L2.08441 18.4707C1.56601 19.7475 2.18041 21.2019 3.45601 21.7215C3.71521 21.8259 3.98881 21.8859 4.26721 21.9015",
    stroke: "#C05717",
    strokeWidth: 2.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1006 16.9233C12.1006 16.4265 12.5038 16.0161 13.0006 16.0161C13.4974 16.0161 13.9006 16.4133 13.9006 16.9101V16.9233C13.9006 17.4201 13.4974 17.8233 13.0006 17.8233C12.5038 17.8233 12.1006 17.4201 12.1006 16.9233Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9882 13.4754V9.75537",
    stroke: "white",
    strokeWidth: 2.025,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.8f0c6a1e.svg";
export { ForwardRef as ReactComponent };